export enum BasePermissions {
    Admin = "Admin",
    Customer = "Customer",
    CustomerRep = "CustomerRep",
    Manager = "Manager",
    Developer = "Developer",
}
